import _ from 'underscore';

angular.module('am4').factory('users', function($http, $q, apiUrl) {
    var ret = function(id) {
        return {
            get: function() {
                return $http.get(apiUrl + '/users/auth0|asset_management_' + id)
                .then(function(res) {
                    return res.data;
                });
            }
        };
    };

    ret.query = function(params) {
        return $http.get(apiUrl + '/users/', {
            params: params
        })
        .then(function(res) {
            return res.data;
        });
    };

    ret.createUser = function createUser(user) {
        var formattedUser = angular.copy(user);

        // Format tag data as simple array of tag IDs
        formattedUser.tags = _.uniq(_.pluck(user.tags, 'tag_id'));

        // Generate random password
        function randomString(length, chars) {
            var result = '';
            for (let i = length; i > 0; --i) {
                result += chars[Math.floor(Math.random() * chars.length)];
            }
            return result;
        }
        formattedUser.password = randomString(32, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');

        return $http.post(apiUrl + '/users', formattedUser);
    };

    ret.updateName = function updateName(user_id, name) {
        var safeUser = encodeURIComponent(user_id);
        return $http.put(apiUrl + '/users/' + safeUser + '/display_name', {
            display_name: name
        });
    };

    ret.updateEmail = function updateEmail(user_id, email) {
        var safeUser = encodeURIComponent(user_id);
        return $http.put(apiUrl + '/users/' + safeUser + '/email', {
            email: email
        });
    };

    ret.updateActiveState = function updateActiveState(user_id, activeState) {
        var safeUser = encodeURIComponent(user_id);

        return $http.put(apiUrl + '/users/' + safeUser + '/enabled', {
            enabled: activeState
        });
    };

    ret.updateDetails = function updateDetails(user_id, details) {
        var safeUser = encodeURIComponent(user_id),

            updates = [
                $http.put(apiUrl + '/users/' + safeUser + '/language', {
                    language: details.language
                }),
                $http.put(apiUrl + '/users/' + safeUser + '/unit_preference', {
                    unit_preference: details.unit_preference
                })
            ];

        if (angular.isDefined(details.roles)) {
            updates.push($http.put(apiUrl + '/users/' + safeUser + '/roles', details.roles));
        }

        return $q.all(updates);
    };

    return ret;
});



// WEBPACK FOOTER //
// ./src/app/services/users.js